import { CustomAttributeFieldConfig } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { CheckboxEditor } from './checkbox-edit';
import { CheckboxView } from './checkbox-view';

export const CHECKBOX_FIELD_CONFIG: CustomAttributeFieldConfig = {
  type: 'checkbox',
  editable: true,
  directEdit: true,
  View: CheckboxView,
  Editor: CheckboxEditor,
  decode: (raw) => ({
    kind: 'checkbox',
    value: typeof raw === 'boolean' ? raw : false,
  }),
  encode: (value) => getKindLikeValueSafely(value, 'checkbox'),
  isEmpty: () => false,
};
